export default "__VITE_ASSET__D42jd7il__"